import type { TableColumnConfig } from '@ipfabric/utils';
import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { selectStickyColumnsSettings } from 'components/Table/model/selectors/selectStickyColumnsSettings';
import { saveTableSettings } from './saveTableSettings';

interface ChangeTableColumnStickyCommand {
  columnKey: TableColumnConfig['key'];
  value: boolean;
}

export const changeTableColumnSticky: TableCommandFactory<
  ChangeTableColumnStickyCommand
> = (cmdContext, dispatch) => async (command) => {
  const oldStickyColumns = cmdContext.getState().settings.stickyColumns;
  const newStickyColumns = {
    // Initialize to default settings rather than empty object.
    // If we wouldn't do that, auto-stuck first column would be
    // unstuck once first other column is stuck.
    // Also, I had to call the selector outside updateState below,
    // otherwise I got state update glitch - components weren't rerendered
    // in this case although state was updated.
    ...(oldStickyColumns ?? selectStickyColumnsSettings(cmdContext.getState())),
    [command.columnKey]: command.value,
  };
  cmdContext.updateState((draft) => {
    draft.settings.stickyColumns = newStickyColumns;
  });

  dispatch(saveTableSettings);
};
